<!--
 * @Author: your name
 * @Date: 2022-02-23 10:26:16
 * @LastEditTime: 2023-07-06 10:50:58
 * @Description: 三方下单
 * @FilePath: \jmssa-vip-customers-front\src\views\place-order\external-order\ExternalOrdersNo.vue
-->
<template>
  <div class="main-wrap externalOrder">
    <div class="externalOrder-top">
      <div class="search-btns">
        <el-form :inline="true">
          <el-form-item v-if="exportStatus === 100">
            <el-button type="primary" @click="setOrder" :loading="keyBtn" :disabled="multipleSelection.length > 0 ? false : true" class="h40">
              {{ keyBtn ? $lang('下单中...') : $lang('立即下单') }}</el-button>
          </el-form-item>
          <el-form-item v-if="exportStatus === 100">
            <el-button
              type="primary"
              class="h40"
              @click="batchCancelOrder"
              :disabled="multipleSelection.length > 0 ? false : true"
              icon="iconfont iconshanchu"
              :loading="cancelLoading"
              >{{ $lang('批量取消') }}</el-button
            >
          </el-form-item>
          <el-form-item v-if="exportStatus === 100">
            <el-button type="primary" class="h40" @click="shopifyAddrDialog = true" :disabled="multipleSelection.length > 0 ? false : true" icon="iconfont iconbianji">
              {{ $lang('修改发货仓库') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="iconfont iconxiazai" type="primary" size="small" :loading="shopifyLoading" @click="shopifyGet" class="h40" plain>
              {{ $lang('同步shopify订单') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="search-condition" id="jmsSearch">
        <el-form :model="searchParam" ref="seach" :inline="true">
          <el-form-item prop="date">
            <el-date-picker
              :clearable="false"
              v-model="searchParam.date"
              type="daterange"
              :range-separator="$lang('至')"
              :start-placeholder="$lang('开始时间')"
              :end-placeholder="$lang('结束时间')"
              class="commonSize"
              @change="selectDate"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="customerOrderId">
            <el-input v-model="searchParam.customerOrderId" :placeholder="$lang('客户订单号')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchChange" icon="iconfont iconchaxun" class="h32">{{ $lang('查询') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="resetSearch" icon="iconfont iconshanchu" class="h32">{{ $lang('清空') }}</el-button>
          </el-form-item>
          <el-form-item class="shopify-text">
            <el-popover
              v-model="shopifyGuide"
              placement="bottom"
              trigger="manual">
              <div class="shopify-guide">
                <p>{{ `${$lang('第一步')}: ${$lang('同步shopify订单')}` }}</p>
                <p>{{ `${$lang('第二步')}: ${$lang('修改发货仓库')}` }}</p>
                <p>{{ `${$lang('第三步')}: ${$lang('立即下单')}` }}</p>
              </div>
              <el-button type="primary" slot="reference" plain @click="shopifyGuide = !shopifyGuide" class="h32">{{ $lang('SHOPIFY使用指南') }}</el-button>
            </el-popover>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="externalOrder-bottom">
      <div class="table-total" v-if="isShowMsg"><span>{{ $lang('本次总共下单') + setOrderCount + $lang('条数据，其中') + successCount + $lang('条下单成功，') + errorCount + $lang('条下单失败，下单失败的请修改完善订单信息') }}</span></div>
      <div class="tabs-nav">
        <div class="tabs-nav-item" v-for="(item, index) in menuItems" :key="index" @click="changeTab(index)" :class="{ active: tabActive === index }">
          {{ $lang(item.orderStatusName) }}<span class="tabs-nav-item-count">{{ item.total }}</span>
        </div>
      </div>
      <JmsTableScroll
        ref="table"
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @size-change="sizeChange"
        :isCheckedAll="isCheckedAll"
        @select-all="handleSelectAll1"
        @select="handleSelectionChange"
        @current-change="currentChange"
      >
        <template #senderName="{ row }">
          <span v-if="row.errorList && !row.errorList['senderName']">{{ row.senderName || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['senderName']" class="errorClass">{{ row.senderName || '--' }}</div>
          <span v-else>{{ row.senderName || '--' }}</span>
        </template>
        <template #senderMobilePhone="{ row }">
          <span v-if="row.errorList && !row.errorList['senderMobilePhone']">{{ row.senderMobilePhone || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['senderMobilePhone']" class="errorClass">{{ row.senderMobilePhone || '--' }}</div>
          <span v-else>{{ row.senderMobilePhone || '--' }}</span>
        </template>
        <template #senderProvinceName="{ row }">
          <span v-if="row.errorList && !row.errorList['senderProvinceName']">{{ row.senderProvinceName || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['senderProvinceName']" class="errorClass">{{ row.senderProvinceName || '--' }}</div>
          <span v-else>{{ row.senderProvinceName || '--' }}</span>
        </template>
        <template #senderCityName="{ row }">
          <span v-if="row.errorList && !row.errorList['senderCityName']">{{ row.senderCityName || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['senderCityName']" class="errorClass">{{ row.senderCityName || '--' }}</div>
          <span v-else>{{ row.senderCityName || '--' }}</span>
        </template>
        <template #senderStreet="{ row }">
          <span v-if="row.errorList && !row.errorList['senderStreet']">{{ row.senderStreet || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['senderStreet']" class="errorClass">{{ row.senderStreet || '--' }}</div>
          <span v-else>{{ row.senderStreet || '--' }}</span>
        </template>
        <template #senderDetailedAddress="{ row }">
          <span v-if="row.errorList && !row.errorList['senderDetailedAddress']">{{ row.senderDetailedAddress || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['senderDetailedAddress']" class="errorClass">{{ row.senderDetailedAddress || '--' }}</div>
          <span v-else>{{ row.senderDetailedAddress || '--' }}</span>
        </template>
        <template #receiverPostalCode="{ row }">
          <span v-if="row.errorList && !row.errorList['receiverPostalCode']">{{ row.receiverPostalCode || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['receiverPostalCode']" class="errorClass">{{ row.receiverPostalCode || '--' }}</div>
          <span v-else>{{ row.receiverPostalCode || '--' }}</span>
        </template>
        <template #receiverName="{ row }">
          <span v-if="row.errorList && !row.errorList['receiverName']">{{ row.receiverName || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['receiverName']" class="errorClass">{{ row.receiverName || '--' }}</div>
          <span v-else>{{ row.receiverName || '--' }}</span>
        </template>
        <template #receiverMobilePhone="{ row }">
          <span v-if="row.errorList && !row.errorList['receiverMobilePhone']">{{ row.receiverMobilePhone || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['receiverMobilePhone']" class="errorClass">{{ row.receiverMobilePhone || '--' }}</div>
          <span v-else>{{ row.receiverMobilePhone || '--' }}</span>
        </template>
        <template #receiverProvinceName="{ row }">
          <span v-if="row.errorList && !row.errorList['receiverProvinceName']">{{ row.receiverProvinceName || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['receiverProvinceName']" class="errorClass">{{ row.receiverProvinceName || '--' }}</div>
          <span v-else>{{ row.receiverProvinceName || '--' }}</span>
        </template>
        <template #receiverCityName="{ row }">
          <span v-if="row.errorList && !row.errorList['receiverCityName']">{{ row.receiverCityName || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['receiverCityName']" class="errorClass">{{ row.receiverCityName || '--' }}</div>
          <span v-else>{{ row.receiverCityName || '--' }}</span>
        </template>
        <template #receiverStreet="{ row }">
          <span v-if="row.errorList && !row.errorList['receiverStreet']">{{ row.receiverStreet || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['receiverStreet']" class="errorClass">{{ row.receiverStreet || '--' }}</div>
          <span v-else>{{ row.receiverStreet || '--' }}</span>
        </template>
        <template #receiverDetailedAddress="{ row }">
          <span v-if="row.errorList && !row.errorList['receiverDetailedAddress']">{{ row.receiverDetailedAddress || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['receiverDetailedAddress']" class="errorClass">{{ row.receiverDetailedAddress || '--' }}</div>
          <span v-else>{{ row.receiverDetailedAddress || '--' }}</span>
        </template>
        <template #goodsTypeName="{ row }">
          <span v-if="row.errorList && !row.errorList['goodsTypeName']">{{ row.goodsTypeName || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['goodsTypeName']" class="errorClass">{{ row.goodsTypeName || '--' }}</div>
          <span v-else>{{ row.goodsTypeName || '--' }}</span>
        </template>
        <template #goodsName="{ row }">
          <span v-if="row.errorList && !row.errorList['goodsName']">{{ row.goodsName || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['goodsName']" class="errorClass">{{ row.goodsName || '--' }}</div>
          <span v-else>{{ row.goodsName || '--' }}</span>
        </template>
        <template #packageTotalWeight="{ row }">
          <span v-if="row.errorList && !row.errorList['packageTotalWeight']">{{ row.packageTotalWeight || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['packageTotalWeight']" class="errorClass">{{ row.packageTotalWeight || '--' }}</div>
          <span v-else>{{ row.packageTotalWeight || '--' }}</span>
        </template>
        <template #expressTypeName="{ row }">
          <span v-if="row.errorList && !row.errorList['expressTypeName']">{{ row.expressTypeName || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['expressTypeName']" class="errorClass">{{ row.expressTypeName || '--' }}</div>
          <span v-else>{{ row.expressTypeName || '--' }}</span>
        </template>
        <template #paymentModeName="{ row }">
          <span v-if="row.errorList && !row.errorList['paymentModeName']">{{ row.paymentModeName || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['paymentModeName']" class="errorClass">{{ row.paymentModeName || '--' }}</div>
          <span v-else>{{ row.paymentModeName || '--' }}</span>
        </template>
        <template #codMoney="{ row }">
          <span v-if="row.errorList && !row.errorList['codMoney']">{{ row.codMoney || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['codMoney']" class="errorClass">{{ row.codMoney || '--' }}</div>
          <span v-else>{{ row.codMoney || '--' }}</span>
        </template>
        <template #codCurrencyTypeName="{ row }">
          <span v-if="row.errorList && !row.errorList['codCurrencyTypeName']">{{ row.codCurrencyTypeName || '--' }}</span>
          <div v-else-if="row.errorList && row.errorList['codCurrencyTypeName']" class="errorClass">{{ row.codCurrencyTypeName || '--' }}</div>
          <span v-else>{{ row.codCurrencyTypeName || '--' }}</span>
        </template>
        <template slot="orderStatusName" slot-scope="data">
          <!-- <span class="dot" :class="data.row.orderStatusName=='待打印'?'oragin':''" v-show="data.row.orderStatusName=='待打印'">{{data.row.orderStatusName}}</span> -->
          <span class="dot" :class="data.row.orderStatusName == '已打印' ? 'oragin' : ''" v-show="data.row.orderStatusName == '已打印'">{{ $lang('未取件') }}</span>
          <span class="dot" :class="data.row.orderStatusName == '已取件' ? 'green' : ''" v-show="data.row.orderStatusName == '已取件'">{{ data.row.orderStatusName }}</span>
          <span class="dot" v-show="data.row.orderStatusName == '已取消'">{{ data.row.orderStatusName }}</span>
        </template>
        <template slot="menu" slot-scope="data">
          <div>
            <!-- 查看按钮 -->
            <el-button @click="rowView(data.row)" type="text">{{ $lang('查看') }}</el-button>
            <el-button @click="rowEdit(data.row, data.index)" type="text">{{ $lang('编辑') }}</el-button>
          </div>
        </template>
      </JmsTableScroll>
    </div>
    <!-- 订单编辑 -->
    <edit :dialogVisible.sync="editDialog" :rowData="editInfo" @save="editSave" @showShopAddr="showShopAddr"/>
    <!-- 订单详情弹框组件 -->
    <bullet ref="bullet" :orderType="orderType" :viewDialogVisible="viewDialogVisible" @closeDetails="closeDetails" :bulletTitle="1" :rowData="rowData"></bullet>
    <!-- 订单下单失败弹框组件 -->
    <fail-order ref="failOrder" :failList="failData"></fail-order>
    <!-- 仓库地址弹窗 -->
    <el-dialog :title="$lang('选择发货仓库')" :visible.sync="shopifyAddrDialog" :close-on-click-modal="false" :modal-append-to-body="true" width="600px">
      <div class="dialog-center">
        <div style="margin-bottom:15px">
          <el-button @click="shopifyAddressListGet" type="text">{{ $lang('获取最新仓库信息') }}</el-button>
        </div>
        <el-radio-group v-model="inventoryAddressId">
          <el-radio :label="item.inventoryId" v-for="item in shopifyAddrList" :key="item.id">{{ item.inventoryName }}</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="h40" @click="batchAddrUpdate" :loading="shopifyLoading">{{ $lang('确认') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import mixin from '@/mixins/mixin.js'
import edit from './components/edit.vue'
import {
  orderListThridNo,
  orderTotalGroupThridNo,
  detailOrder,
  batchSave,
  cancelById,
  shopifyOrderSync,
  shopifyAddressList,
  shopifyOrderAddrUpdate,
  shopifyMyStore
} from '@/api/module/customer'
import dayjs from 'dayjs'
import bullet from '@components/base/BaseBulletThird.vue'
import failOrder from './components/FailOrder.vue'
import { commonFun } from '@utils/common'
import { RESPONSE_SUCCESS } from '@constants'
import { mapActions } from 'vuex'
export default {
  name: 'ExternalOrdersNo',
  mixins: [mixin],
  components: {
    JmsTableScroll,
    bullet,
    failOrder,
    edit
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          const space = 90 * 24 * 3600 * 1000
          const minTime = new Date().getTime() - space
          const noewDate = dayjs(new Date().getTime()).format('YYYY-MM-DD')
          const maxTime = new Date(noewDate + ' 23:59:59').getTime()
          return time.getTime() < minTime || time.getTime() > maxTime
        }
      },
      COM_HTTP: {
        reqList: orderListThridNo,
        reqDetail: detailOrder
      },
      isShowFirst: false,
      searchParam: {
        date: commonFun.GetTodayDate(),
        startTime: commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        endTime: commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
        orderStatusCode: 100, // 页签（all，already_print，already_pick，already_cancle）
        customerOrderId: ''
      },
      orderSourceCodeList: [], // 下单渠道
      menuItems: [], // tab菜单
      multipleSelection: [], // 多选或全选数据
      disabled: true, // 禁止点击状态
      exportStatus: 100, // 未下单的code， 100-未下单，101-商户取消，102-平台取消
      selectId: '', // 当前选中的id
      isCheckedAll: false,
      isKeyUp: false,
      page: {
        // 分页配置
        current: 1,
        size: 100,
        total: 0,
        sizes: [50, 100, 200, 500, 1000]
      },
      tabActive: 0, // tab 选中
      // 21117,多国合一，根据用户的国家code，行政区域的label有变化，下面是沙特(原来)的行政区划
      senderProvinceName: this.$lang('寄件州'),
      senderCityName: this.$lang('寄件城市'),
      receiverProvinceName: this.$lang('收件州'),
      receiverCityName: this.$lang('收件城市'),
      orderType: 'thridNo',
      keyBtn: false,
      cancelLoading: false,
      failData: [],
      shopifyLoading: false, // 同步shopify订单
      inventoryAddressId: '', // 仓库地址选中
      shopifyAddrDialog: false, // 仓库地址弹窗
      shopifyAddrList: [], // 仓库信息
      shopifyDomain: '',
      shopifyGuide: false,
      editDialog: false,
      editInfo: {},
      editIndex: -1,
      isEditShopAddr: false,
      setOrderCount: 0,
      errorCount: 0,
      successCount: 0,
      errorData: [],
      isShowMsg: false,
      isSetOrder: false
    }
  },
  async created() {
    this.isSinleSelection = []
    // 获取订单来源数据
    const key = this.$route.params.typeNum
    // this.getOrderOrigin(key)
    await this.getShopifyStore()
    this.shopifyAddressListGet()
    await this.orderTotalGroupThridNo(this.searchParam)
    if (key) {
      this.handleSelect(key)
    } else {
      this.searchFun()
    }
  },
  computed: {
    listOpt() {
      const that = this
      return {
        border: true,
        selection: true,
        menu: true,
        menuWidth: 100,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        rowKey: '$index',
        fixHeight: 148,
        //  搜索框和表格列及其字段
        column: [
          {
            label: '客户订单号',
            prop: 'customerOrderId',
            width: 150
          },
          {
            label: '寄件人姓名',
            slot: true,
            prop: 'senderName'
          },
          {
            label: '寄件人手机号',
            slot: true,
            prop: 'senderMobilePhone'
          },
          {
            label: that.senderProvinceName,
            slot: true,
            prop: 'senderProvinceName'
          },
          {
            label: that.senderCityName,
            slot: true,
            prop: 'senderCityName'
          },
          {
            label: '寄件街道',
            slot: true,
            prop: 'senderStreet'
          },
          {
            label: '寄件详细地址',
            slot: true,
            prop: 'senderDetailedAddress'
          },
          {
            label: '收件邮编',
            slot: true,
            prop: 'receiverPostalCode'
          },
          {
            label: '收件人姓名',
            slot: true,
            prop: 'receiverName'
          },
          {
            label: '收件人手机号',
            slot: true,
            prop: 'receiverMobilePhone'
          },
          {
            label: that.receiverProvinceName,
            slot: true,
            prop: 'receiverProvinceName'
          },
          {
            label: that.receiverCityName,
            slot: true,
            prop: 'receiverCityName'
          },
          {
            label: '收件街道',
            slot: true,
            prop: 'receiverStreet'
          },
          {
            label: '收件详细地址',
            slot: true,
            prop: 'receiverDetailedAddress'
          },
          {
            label: '物品类型',
            slot: true,
            prop: 'goodsTypeName'
          },
          {
            label: '物品名称',
            slot: true,
            prop: 'goodsName'
          },
          {
            label: '物品重量',
            slot: true,
            prop: 'packageTotalWeight'
          },
          {
            label: '产品类型',
            slot: true,
            prop: 'expressTypeName'
          },
          {
            label: '结算方式',
            slot: true,
            prop: 'paymentModeName'
          },
          {
            label: '代收货款金额',
            slot: true,
            prop: 'codMoney'
          },
          {
            label: '代收货款币别名称',
            slot: true,
            prop: 'codCurrencyTypeName'
          }
        ]
      }
    },
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    countryCode() {
      return this.$store.state.base.user.countryCode || ''
    }
  },
  watch: {
    tableList: {
      handler(oldVal, newVal) {
        if (this.isKeyUp && this.exportStatus === 'already_print' && this.tableList.length === 1 && this.autoPrint) {
          this.autoPrint = false
          this.multipleSelection = this.tableList
          this.$nextTick(() => {
            this.$refs.table.$refs.table.toggleRowSelection(this.tableList[0], true)
            this.$refs.printOrder && this.$refs.printOrder.$refs.btnPrint.$el.click()
          })
        }
      },
      deep: true
    },
    countryCode: {
      handler(val) {
        const that = this
        if (val === 'UAE') {
          // 阿联酋的用户行政区域要变
          that.senderProvinceName = that.$lang('寄件酋长国')
          that.senderCityName = that.$lang('寄件区域')
          that.receiverProvinceName = that.$lang('收件酋长国')
          that.receiverCityName = that.$lang('收件区域')
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['LOGIN_OUT', 'SET_USER', 'UPDATE_PRINT_STOCK']),
    rowEdit(row, index) {
      this.editInfo = row
      this.editIndex = index
      this.editDialog = true
    },
    editSave(val) {
      this.$set(this.tableList, this.editIndex, val)
    },
    /**
     * @description: 獲取shopify 店铺列表
     * @param {*}
     * @return {*}
     */
    async getShopifyStore() {
      const res = await shopifyMyStore()
      try {
        if (res.code === RESPONSE_SUCCESS && res.data) {
          this.shopifyDomain = res.data.storeDomain
        }
      } catch (error) {
        this.shopifyDomain = ''
      }
    },
    // 选择分页条数
    sizeChange(val, list) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
      this.multipleSelection = []
      this.isCheckedAll = false
    },
    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.searchFun()
      this.multipleSelection = []
      this.isCheckedAll = false
    },
    handleCompositionEnd(e) {
      // 中文输入法回车事件
      const { data } = e || {}
      if (data.length > 11) {
        this.searchParam.startTime = commonFun.getBeforeDate(30) + ' 00:00:00'
        this.searchParam.endTime = commonFun.GetTodayDate()[1] // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        this.searchParam.date = [this.searchParam.startTime, this.searchParam.endTime]
        this.searchChange()
      }
    },
    toKeyUp(e) {
      if (this.isKeyUp) {
        // 回车搜索后首次输入清空输入框
        this.isKeyUp = false
      }
      return true
    },
    async payCode(e) {
      // const code = e.keyCode || e.which
      // if (code === 13) {
      this.isKeyUp = true
      this.autoPrint = true
      const nos = this.searchParam.customerWaybillNos
      if (nos.length === 0 || (nos.length > 0 && nos[0] === '')) {
        this.searchParam.customerWaybillNos = []
      } else {
        this.searchParam.startTime = commonFun.getBeforeDate(30) + ' 00:00:00'
        this.searchParam.endTime = commonFun.GetTodayDate()[1] // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        this.searchParam.date = [this.searchParam.startTime, this.searchParam.endTime]
        this.searchFun(1)
        // await this.searchChange()
      }
      // }
    },

    /**
     * @description: 获取shopify 仓库信息
     * @param {*}
     * @return {*}
     */
    async shopifyAddressListGet() {
      this.shopifyLoading = true
      const { code, data } = await shopifyAddressList({ domain: this.shopifyDomain || '' })
      if (code === RESPONSE_SUCCESS && data) {
        this.shopifyAddrList = data
      } else {
        this.shopifyAddrList = []
      }
      this.$nextTick(() => {
        this.shopifyLoading = false
        this.shopifyAddrDialog = false
      })
    },

    /**
     * @description: 同步shopify订单
     * @param {*}
     * @return {*}
     */
    async shopifyGet() {
      this.shopifyLoading = true
      const { code } = await shopifyOrderSync({ domain: this.shopifyDomain || '' })
      if (code === RESPONSE_SUCCESS) {
        this.searchChange()
      }
      this.$nextTick(() => {
        this.shopifyLoading = false
      })
    },
    /**
     * @description: 批量修改地址
     * @param {*}
     * @return {*}
     */
    async batchAddrUpdate() {
      if (!this.inventoryAddressId) {
        this.$message.warning(this.$lang('请选择发货仓库'))
        return
      }
      const ids = []
      this.multipleSelection.forEach(item => {
        if (item.orderStatusCode === 100) {
          ids.push(item.customerOrderId)
        }
      })
      this.shopifyLoading = true
      const { code, msg } = await shopifyOrderAddrUpdate({ customerOrderId: ids, inventoryAddressId: this.inventoryAddressId, domain: this.shopifyDomain || '' })
      if (code === RESPONSE_SUCCESS) {
        this.shopifyAddrDialog = false
        this.searchChange()
        this.$message.success(this.$lang('修改成功'))
      } else {
        this.$message.error(msg)
      }
      this.$nextTick(() => {
        this.shopifyLoading = false
      })
    },
    showShopAddr(val) {
      this.shopifyAddrDialog = true
    },
    // 批量取消订单
    async batchCancelOrder() {
      const customerOrderId = []
      this.multipleSelection.forEach(item => {
        if (item.orderStatusCode === 100) {
          customerOrderId.push(item.customerOrderId)
        }
      })
      if (customerOrderId.length <= 0) {
        this.$message.warning(this.$lang('没有可取消的订单'))
        return
      }
      this.cancelLoading = true
      const { code, msg } = await cancelById({ customerOrderId, domain: this.shopifyDomain || '' })
      this.cancelLoading = false
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('取消成功'))
      } else {
        this.$message.error(msg)
      }
      this.cancelSuccess()
    },

    // 选择日期
    selectDate() {
      console.log(this.searchParam.date, 'this.searchParam.date')
      const [start = '', end = ''] = this.searchParam.date
      this.searchParam.startTime = start
      this.searchParam.endTime = end
    },
    getParams() {
      const { orderStatusCode } = this.searchParam
      const searchParam = Object.assign({}, this.searchParam)
      // const arr = ['current', 'size', 'startTime', 'endTime', 'date', 'orderStatusCode', 'columnNames', 'sort', 'orderStatusCode', 'isVip']
      // Object.keys(searchParam).forEach(item => {
      //   if (!arr.includes(item)) {
      //     if (searchParam[item] instanceof Array && searchParam[item][0]) {
      //       delete searchParam.startTime
      //       delete searchParam.endTime
      //     } else if (typeof searchParam[item] === 'string' && searchParam[item]) {
      //       delete searchParam.startTime
      //       delete searchParam.endTime
      //     }
      //   }
      // })
      searchParam.orderStatusCode === '0' ? '' : orderStatusCode
      searchParam.isVip = false
      return searchParam
    },
    // 查询
    async searchChange(params) {
      const { startTime, endTime } = this.searchParam
      const space = 31 * 24 * 3600 * 1000
      const startTime1 = new Date(startTime).getTime()
      const endTime1 = new Date(endTime).getTime()
      if (endTime1 - startTime1 > space) {
        this.$message.error(this.$lang('开始时间与结束时间之差不能大于31天'))
        return
      }
      this.searchParam.orderStatusCode = this.menuItems.length > 0 ? this.menuItems[this.tabActive].orderStatusCode : ''
      this.searchParam.customerOrderId = this.searchParam.customerOrderId.length > 0 ? this.searchParam.customerOrderId : ''
      // 列表查询
      await this.searchFun(1)
      // 列表总数查询
      await this.orderTotalGroupThridNo(this.searchParam)
      this.multipleSelection = []
    },
    handleSelect(key) {
      const menuItems = this.menuItems
      this.searchParam.orderStatusCode = menuItems[key].orderStatusCode
      this.exportStatus = menuItems[key].orderStatusCode
      this.tabActive = key
      this.currentKey = parseInt(key)
      this.page.current = 1
      this.isCheckedAll = false
      // 重置表格滚动条置顶
      this.$refs.table.$el.querySelector('.el-table__body-wrapper').scrollTop = 0
      this.searchFun()
      // 清空选中数据
      this.multipleSelection = []
      this.autoPrint = false
      // 列表总数查询
      this.orderTotalGroupThridNo(this.searchParam)
      this.$nextTick(() => {
        this.$refs.table.$refs.table.doLayout()
      })
    },
    cancelFn(row) {
      this.selectId = row.id
      this.$refs.cancelOrder.dialogTableVisible = true
    },
    // 取消成功
    cancelSuccess() {
      this.multipleSelection = []
      this.isCheckedAll = false
      setTimeout(() => {
        this.orderTotalGroupThridNo(this.searchParam)
        this.searchFun()
      }, 1000)
    },
    // 获取tabs
    async orderTotalGroupThridNo(reqData) {
      // 状态数据统计
      reqData.isVip = false
      const params = this.getParams()
      // tabs默认获取全部，orderStatusCode默认不传
      params.orderStatusCode = ''
      const { code, data } = await orderTotalGroupThridNo(params)
      if (code === RESPONSE_SUCCESS) {
        const list = [...data]
        if (list.length > 0 && list[0].total === 0 && this.isKeyUp) {
          this.$message.warning('查询不到订单信息')
        }
        this.menuItems = list
      }
    },
    // 查看
    rowView(row) {
      this.selectId = row.id
      this.viewDialogVisible = true
      // 获取查看详情
      this.viewFun(row)
    },
    // close:关闭；delWaybill删除运单  ； cancelOrder:取消订单； ediOrder:编辑订单 delOrder:删除订单；
    closeDetails(val) {
      this.viewDialogVisible = val.viewDialogVisible
      switch (val.type) {
        case 'cancelOrder':
          this.$refs.cancelOrder.dialogTableVisible = true
          break
        case 'ediOrder':
          this.editDialogVisible = true
          break
        case 'delOrder':
          const item = {
            orderId: val.rowData.id
          }
          this.rowDel(item)
          break
      }
    },
    // 重置编辑表单
    clearFormItem() {
      this.$refs['editOrder'].$refs['orderForm'].resetFields()
    },
    // 重置搜索
    resetSearch() {
      this.searchParam = {
        date: commonFun.GetTodayDate(),
        startTime: commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        endTime: commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
        customerOrderId: ''
      }
    },
    // 全选
    handleSelectAll1(val) {
      this.multipleSelection = val
      this.originSelectionAll = [...val]
      if (val.length) {
        this.isCheckedAll = true
      } else {
        this.isCheckedAll = false
      }
    },
    // 单个选中
    handleSelectionChange(val, currentRow) {
      // 检测当前行的选中状态
      const isChecked = val.some(item => item.id === currentRow.id)
      if (this.isCheckedAll) {
        if (!isChecked) {
          this.isSinleSelection = [...(this.isSinleSelection || []), currentRow.id]
        } else {
          this.isSinleSelection = this.isSinleSelection.filter(item => item !== currentRow.id)
        }
        this.multipleSelection = this.originSelectionAll.filter(item => !this.isSinleSelection.includes(item.id))
      } else {
        this.multipleSelection = val
      }
    },
    changeTab(index) {
      this.tabActive = index
      this.handleSelect(index)
    },
    // 下单
    async setOrder() {
      try {
        this.failData = []
        this.keyBtn = true
        if (this.multipleSelection.length === 0) return this.$message.warning(this.$lang('请选择要下单的订单'))
        const orders = []
        this.multipleSelection.forEach((item, index) => {
          orders.push({
            ...item,
            sallaOrderId: item.id,
            goodsTypeName: 'Others1',
            goodsTypeCode: 'ITN4',
            id: ''
          })
        })
        this.setOrderCount = this.multipleSelection.length

        // 下单前各按钮和提示按钮初始化
        const { code, msg, data } = await batchSave({
          orders: orders
        })
        this.keyBtn = false
        if (code === RESPONSE_SUCCESS) {
          this.isSetOrder = true
          if (data && data.length) {
            this.errorCount = data.length
            this.errorData = data
            this.successCount = this.setOrderCount - this.errorCount
          } else {
            this.errorCount = 0
            this.errorData = []
            this.successCount = this.setOrderCount - this.errorCount
          }
          this.multipleSelection = []
          this.isCheckedAll = false
          // this.$message.success(this.$lang('下单成功'))
          setTimeout(() => {
            this.orderTotalGroupThridNo(this.searchParam)
            this.searchFun()
          }, 1000)
        } else {
          this.$message.error(msg)
          // this.$nextTick(() => {
          //   this.multipleSelection.forEach((item, index) => {
          //     this.failData[index] = { customerOrderId: item.customerOrderId }
          //   })
          //   this.$refs.failOrder.dialogTableVisible = true
          // })
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 查询方法
    async searchFun(current) {
      let searchFunTime = null
      clearTimeout(searchFunTime)
      this.loading = true
      // 重置表格滚动条置顶
      if (this.$refs.table) {
        this.$refs.table.$el.querySelector('.el-table__body-wrapper').scrollTop = 0
      }
      // 传入参数有current
      if (current) {
        this.page.current = current
      }
      // 获取定时器ID
      searchFunTime = setTimeout(async () => {
        // 清空定时器ID
        this.searchFunTime = null
        if (typeof this.searchFunBefore === 'function') {
          const state = this.searchFunBefore()
          if (!state) {
            this.loading = false
            return
          }
        }
        // 添加超时清除loading状态的定时器
        const timeState = setTimeout(() => {
          if (this.loading) this.loading = false
        }, 15000)
        const newParams = Object.assign({ current: this.page.current, size: this.page.size }, this.getParams())
        const res = await this.COM_HTTP.reqList(newParams)
        // 清除超时定时器
        clearTimeout(timeState)
        this.loading = false
        if (res.code === RESPONSE_SUCCESS) {
          this.tableList = res.data.records ? (this.formatList ? this.formatList(res.data) : res.data.records) : []
          if (this.isSetOrder && this.errorData && this.errorData.length) {
            this.tableList = this.tableList.map(v => {
              const temp = this.errorData.find(a => a.errorList.customerOrderId === v.customerOrderId)
              if (temp) {
                return {
                  ...v,
                  errorList: temp.errorList
                }
              } else {
                return { ...v }
              }
            })
            this.errorData = []
            this.isShowMsg = true
            this.isSetOrder = false
          } else {
            if (this.isSetOrder) {
              this.isShowMsg = true
              this.isSetOrder = false
            } else {
              this.isShowMsg = false
            }
          }
          this.page.total = res.data.total || 0
          this.page.current = res.data.current || 1
        } else {
          this.$message.error(res.msg)
        }
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
.externalOrder {
  .errorClass {
    background-color: #E60002;
    opacity: 0.7;
    color: #ffffff;
  }
}
.el-form-item {
  margin-bottom: 0;
}
.el-menu-item {
  height: 32px;
  line-height: 32px;
  padding: 0 3px;
  margin: 0 20px;
  text-align: center;
}
.el-menu-item:first-of-type {
  padding-left: 0;
  margin-left: 0;
  text-align: left;
}
input {
  font-size: 12px !important;
}
.externalOrder {
  .externalOrder-top {
    padding: 16px 24px;
    .commonSize {
      width: 328px !important;
      height: 32px !important;
    }
  }
  .externalOrder-bottom {
    padding: 12px 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #edeef3;
    box-sizing: border-box;
    .table-total {
      height: 48px;
      line-height: 48px;
      text-align: center;
      background-color: #edf7e6;
      color: #8ad236;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }

  .search-btns {
    margin-bottom: 10px;
  }

  .shopify-text {
    float: right;
  }
  .tabs-nav {
    // margin: 5px 0 9px;
    .tabs-nav-item {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      padding: 12px 20px;
      font-size: 16px;
      background: #e0e1e7;
      height: 40px;
      border: 0;
      background: #e0e1e7;
      border-radius: 8px 8px 0 0;
      color: #666;
      margin-left: 10px;
      &:first-of-type {
        margin-left: 0px;
      }
      i {
        margin-right: 8px;
        color: #666;
      }
      &.active {
        background: #fff;
        color: #e60012;
        i {
          color: #e60012;
        }
      }
    }
    .tabs-nav-item-count {
      display: inline-block;
      width: 35px;
      height: 20px;
      font-size: 12px;
      line-height: 20px;
      background: rgba(102, 102, 102, 0.1);
      border-radius: 10px;
      margin-left: 5px;
    }
  }
}

.shopify-guide {
  padding: 0 20px;
}
</style>
<style lang="scss">
.externalOrder .externalOrder-top .el-input__inner {
  margin-bottom: 10px;
}
.customerWaybillNos .el-input__inner {
  margin-bottom: 0px !important;
}
</style>
